import React, { Fragment } from 'react'
import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Icon,
    TablePagination,
} from '@material-ui/core';

const OrderProductListMini = ({ProductList}) => {
    const Products = [];
    Object.keys(ProductList).map(function(data,number){
        if(ProductList[data] !== null) {
            const item = ProductList[data];
            const NamePR = item['name'];
            const CountPR = item['count'];
            const PricePR = item['price'];
            const OriginalPricePR = item['originalPrice'] !== undefined && item['originalPrice'] !== null
                ? item['originalPrice']
                : item['original_price'];
            const parentLocal = item['parentLocalId'] || item['parent_local_id'] || null;
            const isMod = item['isModifier'] === true || item['is_modifier'] === true || (!!parentLocal && parentLocal !== 0);
            const fontSize = isMod ? '12px' : undefined;
            const paddingLeft = isMod ? '12px' : undefined;
            const hasDiscountedView = Number(OriginalPricePR) > Number(PricePR);

            Products.push(<tr key={number}><td style={{width:"55%",
                overflowWrap: "normal",  /* не поддерживает IE, Firefox; является копией word-wrap */
                wordWrap: "normal",
                wordBreak: "normal",  /* не поддерживает Opera12.14, значение keep-all не поддерживается IE, Chrome */
                lineBreak: "auto",  /* нет поддержки для русского языка */
                hyphens: "manual",  /* значение auto не поддерживается Chrome */
                padding:"2% 0",
                paddingLeft,
                fontSize
            }}>{isMod ? '+ ' : ''}{NamePR}</td><td style={{width:"20%", fontSize}}>{CountPR} шт</td><td style={{width:"25%", fontSize}}>
                {hasDiscountedView ? (
                    <div style={{display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1}}>
                        <span style={{
                            textDecoration: 'line-through',
                            opacity: 0.6,
                            fontSize: isMod ? '10px' : '11px',
                            marginBottom: '-2px'
                        }}>{OriginalPricePR} ₽</span>
                        <span>{PricePR} ₽</span>
                    </div>
                ) : (
                    <span>{PricePR} ₽</span>
                )}
            </td></tr>);
        }else{
            Products.push(<tr key={number}>Нет данных</tr>);
        }
    }).join('');

    //console.log(Products);
    return (
        <Table><thead></thead><tbody>{Products}</tbody></Table>
    );
};




export default OrderProductListMini;
